/**
 * Used to check whether to display the captcha challenge depend on the payment method and
 * settings.
 *
 * Use "checkPaymentMethod" argument to check only the specific payment method.
 *
 * This helper binds with the settings variable to pass "settings" and keep them, without
 * necessity to pass them every next call.
 */
export const showCaptchaChallenge = (settings, paymentMethod, checkPaymentMethod = null) => {
  if (
    /^decoupled_stripe_button_/.test(paymentMethod) &&
    settings.showGoogleAppleCaptcha &&
    (!checkPaymentMethod || checkPaymentMethod === 'google_apple')
  ) {
    return true;
  } else if (
    /^decoupled_stripe_credit_card_/.test(paymentMethod) &&
    settings.showCreditCardCaptcha &&
    (!checkPaymentMethod || checkPaymentMethod === 'credit_card')
  ) {
    return true;
  }

  return false;
};